import { SxProps } from '@mui/material';

const panelCard: SxProps = {
  p: { xs: 2, sm: 3 },
  borderRadius: 3,
  marginTop: 2,
  border: '1px solid #E5E7EB',
  background: '#fff',
};

const headerRow: SxProps = {
  alignItems: { xs: 'flex-start', md: 'center' },
  justifyContent: 'space-between',
  rowGap: 1.5,
};

const descriptionText: SxProps = { mt: 0.5 };

const actionsRow: SxProps = {
  alignItems: 'center',
};

const filterRow: SxProps = {
  '& .MuiFormControl-root': {
    minWidth: { md: 160 },
  },
};

const statsRow: SxProps = {
  columnGap: 1.5,
  rowGap: 1,
};

const emptyState: SxProps = { textAlign: 'center', py: 4 };

const listBox: SxProps = { border: '1px solid #F0F0F0', borderRadius: 2 };

const listRow: SxProps = { px: 2, py: 1.5 };

const statPillBox: SxProps = {
  flex: 1,
  p: 1.5,
  borderRadius: 2,
  border: '1px solid #F0F0F0',
  background: '#F9FAFB',
};

const paginationRow: SxProps = {
  mt: 1,
};

export {
  panelCard,
  headerRow,
  descriptionText,
  actionsRow,
  filterRow,
  statsRow,
  emptyState,
  listBox,
  listRow,
  statPillBox,
  paginationRow,
};
